import { useEffect, useState } from 'react'
import { washPackages as staticWashPackages, formatTierPriceDisplay } from '@/config/washCatalog'
import { washCatalogService } from '@/services/washCatalogService'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

const OFFICIAL_SHEET = '/brand/price-list.jpg'

function OfficialPriceSheetImage() {
  const [show, setShow] = useState(false)
  useEffect(() => {
    fetch(OFFICIAL_SHEET, { method: 'HEAD' })
      .then((r) => setShow(r.ok))
      .catch(() => setShow(false))
  }, [])
  if (!show) return null
  return (
    <figure className="mt-6 space-y-2">
      <img
        src={OFFICIAL_SHEET}
        alt="Official wash price list from TrendSetter"
        className="max-h-[min(520px,75vh)] w-full rounded-md border border-border object-contain object-left bg-muted/20"
        loading="lazy"
      />
      <figcaption className="text-xs text-muted-foreground">
        Official wash price list.
      </figcaption>
    </figure>
  )
}

export default function WashPriceListSection() {
  const [washPackages, setWashPackages] = useState(staticWashPackages)
  useEffect(() => {
    ;(async () => {
      try {
        await washCatalogService.ensureInitialized()
        const doc = await washCatalogService.get()
        if (doc?.packages?.length) setWashPackages(doc.packages)
      } catch (e) {
        console.error(e)
      }
    })()
  }, [])

  const tierLabels = washPackages[0]?.tiers.map((t) => t.label) ?? []

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Wash price list</CardTitle>
        <CardDescription>
          All prices in ZAR. Same structure staff use at check-in.
        </CardDescription>
      </CardHeader>
      <CardContent className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="min-w-[140px]">Service</TableHead>
              {tierLabels.map((label) => (
                <TableHead key={label} className="text-right whitespace-nowrap">
                  {label}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {washPackages.map((pkg) => (
              <TableRow key={pkg.id}>
                <TableCell className="font-medium">
                  <div>{pkg.name}</div>
                  {pkg.description && (
                    <div className="text-xs text-muted-foreground font-normal mt-0.5">
                      {pkg.description}
                    </div>
                  )}
                </TableCell>
                {pkg.tiers.map((t) => (
                  <TableCell key={t.id} className="text-right tabular-nums">
                    {formatTierPriceDisplay(t)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <OfficialPriceSheetImage />
      </CardContent>
    </Card>
  )
}
